module.exports = __webpack_public_path__ + "img/icon-tag-light.6cdcce0b.svg";